import { Action } from 'redux';

import { CancelBackgroundJob } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { ICancelBackgroundJobParams } from '../types/CancelBackgroundJobRequest';

export interface CancelBackgroundJobAction extends Action {
  params: ICancelBackgroundJobParams;
}

export function cancelBackgroundJobAction(params: ICancelBackgroundJobParams) {
  return {
    type: CancelBackgroundJob,
    params,
  };
}

export const isCancelBackgroundJobAction = isActionFactory<CancelBackgroundJobAction>(CancelBackgroundJob);
